import React, { useState } from "react";

import { faFile } from "@fortawesome/pro-regular-svg-icons";
import { faChevronDown, faChevronUp } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import type { AskSource } from "@performyard/service-contracts";

type SourcesBoxProps = {
	sources: AskSource[];
	onSourceClick: (s3FileId: string, filename: string) => void;
};

export const SourcesBox: React.FC<SourcesBoxProps> = ({ sources, onSourceClick }) => {
	const [isExpanded, setIsExpanded] = useState(false);

	if (sources.length < 2) {
		return null;
	}

	return (
		<div className="mt-2 flex w-full flex-col overflow-hidden rounded-[4px] border border-solid border-[#E9EAEC] bg-[#F5F5F5]">
			{/* Header */}
			<button
				type="button"
				onClick={() => setIsExpanded(!isExpanded)}
				className="box-border flex w-full appearance-none items-center justify-between rounded-t border-0 border-b border-solid border-[#E9EAEC] bg-[#F5F5F5] px-2 py-1 [box-shadow:none] outline-hidden hover:bg-neutral-200"
			>
				<span className="text-xs leading-4 text-[#525861]">Sources ({sources.length})</span>
				<FontAwesomeIcon
					icon={isExpanded ? faChevronUp : faChevronDown}
					className="h-3 w-[9px] shrink-0 text-[#525861]"
				/>
			</button>

			{/* Sources List */}
			{isExpanded && (
				<div className="flex w-full flex-col gap-1 overflow-hidden bg-[#F5F5F5] px-2 py-1">
					{sources.map((source) => (
						<button
							key={source.s3FileId}
							type="button"
							onClick={() => onSourceClick(source.s3FileId, source.filename)}
							className="box-border flex w-[95%] min-w-0 cursor-pointer appearance-none items-center gap-1 overflow-hidden border-0 bg-transparent py-0.5 text-left text-primary-5 [box-shadow:none] outline-hidden hover:!text-primary-7 hover:underline"
						>
							<FontAwesomeIcon icon={faFile} className="h-4 w-4 shrink-0" />
							<span className="w-0 flex-grow truncate text-xs leading-4 font-semibold">
								{source.filename}
							</span>
						</button>
					))}
				</div>
			)}
		</div>
	);
};

export default SourcesBox;
